/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["page-select-table[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{background-color:transparent}page-select-table[_ngcontent-%COMP%]   .scroll-content[_ngcontent-%COMP%]{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;overflow:hidden}page-select-table[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:100%;border-radius:10px;overflow:hidden}page-select-table[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:1.5em}page-select-table[_ngcontent-%COMP%]   .input-item[_ngcontent-%COMP%]{padding-right:16px}"];
export { styles as styles };
